export function normalizeTags(value: unknown): string[] {
  const rawParts = Array.isArray(value)
    ? value
    : typeof value === 'string'
      ? value.split(/[,\n;]/)
      : [];

  const seen = new Set<string>();
  const tags: string[] = [];

  for (const part of rawParts) {
    const normalized = String(part || '').trim().replace(/\s+/g, ' ');
    if (!normalized) {
      continue;
    }

    const dedupeKey = normalized.toLowerCase();
    if (seen.has(dedupeKey)) {
      continue;
    }

    seen.add(dedupeKey);
    tags.push(normalized);
  }

  return tags;
}

export function matchesTemplateSearchQuery(
  template: {
    id: string;
    name: string;
    tags?: readonly string[];
  },
  query: string
): boolean {
  const normalizedQuery = String(query || '').trim().toLowerCase();
  if (!normalizedQuery) {
    return true;
  }

  const tokens = normalizedQuery.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) {
    return true;
  }

  const searchableValues = [
    template.name.toLowerCase(),
    template.id.toLowerCase(),
    ...(template.tags || []).map((tag) => tag.toLowerCase())
  ];

  return tokens.every((token) => searchableValues.some((value) => value.includes(token)));
}
